import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.4.1_@babel+core@8.0.7_@playwright+test@1.64.0_@types+node@22.20.5_babel-plugin-_4173389034d7ddf18b7a6383801703b5/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionHeader"] */ "/opt/build/repo/packages/react/src/accordion/header/AccordionHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionItem"] */ "/opt/build/repo/packages/react/src/accordion/item/AccordionItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionPanel"] */ "/opt/build/repo/packages/react/src/accordion/panel/AccordionPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionRoot"] */ "/opt/build/repo/packages/react/src/accordion/root/AccordionRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionTrigger"] */ "/opt/build/repo/packages/react/src/accordion/trigger/AccordionTrigger.tsx");
